import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { extractURLAndEncodedFilename } from "../utils/helper";
import { getPresignedUrlForFile } from "../helperApi/helperApi";

function ConsignmentPhotoViewer({
  images,
  altText,
  handleConsignmentFileDelete,
  parentModalVisibilityFunction,
  canRemoveImage,
  handleRemoveImage
}) {
  const [show, setShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageUrls, setImageUrls] = useState([]);
  let email = localStorage.getItem("email");
  useEffect(() => {
    async function fetchImageUrls() {
      const urls = await Promise.all(
        images.map(async (image) => {
          if (image?.originalname) {
            return await getPresignedUrlForFile(image.bucket, image.key);
          }
          return (image instanceof File || image instanceof Blob) ? URL.createObjectURL(image) : "";
        })
      );
      setImageUrls(urls);
    }

    fetchImageUrls();
  }, [images]);

  const handleClose = () => {
    setShow(false);
    parentModalVisibilityFunction && parentModalVisibilityFunction(true);
  };

  const handleShow = (index) => {
    setCurrentIndex(index);
    setShow(true);
  };

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % images.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((currentIndex - 1 + images.length) % images.length);
  };

  const handleImageDownload = async (index, file) => {
    if (images[index] instanceof File || images[index] instanceof Blob) {
      const url = URL.createObjectURL(images[index]);
      const downloadName = images[index].name || "downloaded-image";
      const link = document.createElement('a');
      link.href = url;
      link.download = downloadName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      await downloadFileFromS3(file);
    }
  };


  const handleDelete = (currentIndex) => {
    if (images.length == 1) {
      setShow(false);
    }
    handleConsignmentFileDelete(currentIndex);
    if (currentIndex >= 1) {
      setCurrentIndex(currentIndex - 1);
    } else {
      setCurrentIndex(images.length - 1);
    }
  };


  return (
    <div className="photo-view-div flex flex-wrap gap-y-2 ">
      {images.map((image, index) => (
        <div key={index} className="relative w-[150px] h-[100px] mr-2 my-1.5 inline-block">
          <img
            src={imageUrls[index] || "placeholder.jpg"}
            alt={altText}
            onClick={() => handleShow(index)}
            className="w-full h-full object-contain border rounded cursor-pointer"
          />

          {/* Conditionally render remove icon */}
          {typeof canRemoveImage === "function" && canRemoveImage(image) && (
            <button
              onClick={() => handleRemoveImage(index)}
              className="absolute top-0 right-1 text-black text-lg font-bold leading-none hover:scale-110 transition-transform z-10"
              title="Remove image"
              style={{ background: "none", border: "none" }}
            >
              ×
            </button>
          )}

        </div>
      ))}



      <Modal show={show} onHide={handleClose} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '15px' }}>
            Consignment Photo Name: {images[currentIndex]?.originalname || images[currentIndex]?.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='flex justify-center items-center gap-x-1'>
          <img
            src={imageUrls[currentIndex] || "placeholder.jpg"}
            alt={altText}
            style={{ height: "60vh", maxWidth: '100%' }}
          />
          <div style={{
            position: 'absolute', top: '45%', left: '2%', cursor: 'pointer',
            fontSize: '100px', backgroundColor: 'lightgray', padding: '0px 10px', opacity: 0.5
          }} onClick={handlePrevious}>
            <span style={{ opacity: 1 }}>&#8249;</span>
          </div>
          <div style={{
            position: 'absolute', top: '45%', right: '2%', cursor: 'pointer',
            fontSize: '100px', backgroundColor: 'lightgray', padding: '0px 10px', opacity: 0.5
          }} onClick={handleNext}>
            <span style={{ opacity: 1 }}>&#8250;</span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="req-quote-btn"
            onClick={() => handleImageDownload(currentIndex)}
          >
            Download
          </button>
          {email.split("@")[1] == "8xparts.com" ? (
            <>
              <button
                className="req-quote-btn"
                style={{ background: "red" }}
                onClick={() => handleDelete(currentIndex)}
              >
                Delete
              </button>
            </>
          ) : (
            <></>
          )}

          <button
            className="req-quote-btn"
            style={{ background: "gray" }}
            onClick={handleClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ConsignmentPhotoViewer;
